import React, { memo, useEffect, useRef } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { useHover } from 'react-native-web-hooks';

export interface HoverableButtonProps {
  children: (isHovered: boolean) => JSX.Element;
  onPress?: () => void;
  onHoverIn?: () => void;
  onHoverOut?: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
}

const HoverableButton = ({
  onPress,
  onHoverIn,
  onHoverOut,
  style,
  containerStyle,
  children,
  disabled,
}: HoverableButtonProps) => {
  const buttonRef = useRef<View>(null);
  const isHovered = useHover(buttonRef);

  useEffect(() => {
    if (isHovered) {
      onHoverIn?.();
    }

    if (!isHovered) {
      onHoverOut?.();
    }
  }, [isHovered, onHoverOut, onHoverIn]);

  return (
    <View ref={buttonRef} style={containerStyle}>
      <TouchableOpacity onPress={onPress} style={style} disabled={disabled}>
        {children(isHovered)}
      </TouchableOpacity>
    </View>
  );
};

export default memo(HoverableButton);
